import app from 'flarum/forum/app';
import deckColumnTypes from '../columns/deckColumnTypes';
import { DEFAULT_WIDTH } from './deckSizes';
export const PREFERENCE_KEY = 'deckColumns';
export const SPLIT_PREFERENCE_KEY = 'deckRowSplit';
export function canUseDeck() {
  return !!app.session.user && !!app.forum.attribute('canUseDeck');
}
export function maxColumns() {
  return app.forum.attribute('deckMaxColumns') || 8;
}
export function newColumnId() {
  return Math.random().toString(36).slice(2, 10);
}
export function makeColumn(type, params, width) {
  if (params === void 0) {
    params = {};
  }
  if (width === void 0) {
    width = DEFAULT_WIDTH;
  }
  return {
    id: newColumnId(),
    type,
    width,
    row: 0,
    params
  };
}

/**
 * The member's saved layout, or a starter deck if they've never saved one.
 * Columns whose type is unknown or unavailable (an extension was disabled, a
 * permission was revoked) are hidden but kept, so they come back if it does.
 */
export function storedColumns() {
  const stored = app.session.user?.preferences()?.[PREFERENCE_KEY];
  if (Array.isArray(stored)) return stored;
  return defaultColumns();
}
export function hasCustomLayout() {
  return Array.isArray(app.session.user?.preferences()?.[PREFERENCE_KEY]);
}

/**
 * flarum/subscriptions registers this column. Named here rather than imported,
 * so Deck doesn't depend on it: without it, the starter deck uses All instead.
 */
const FOLLOWING = 'flarum-subscriptions.following';
export function defaultColumns() {
  const starter = deckColumnTypes.has(FOLLOWING) && deckColumnTypes.get(FOLLOWING).isAvailable() ? FOLLOWING : 'all';
  return [makeColumn(starter), makeColumn('unread'), makeColumn('notifications')].filter(column => isDisplayable(column));
}
export function isDisplayable(column) {
  return deckColumnTypes.has(column.type) && deckColumnTypes.get(column.type).isAvailable();
}

/** Null clears the layout, so the member follows the default (and any later change to it). */
export function saveColumns(columns) {
  return app.session.user.savePreferences({
    [PREFERENCE_KEY]: columns
  });
}

/** The top row's share of the height; null for an even split. */
export function storedSplit() {
  const split = app.session.user?.preferences()?.[SPLIT_PREFERENCE_KEY];
  return typeof split === 'number' ? split : null;
}
export function saveSplit(split) {
  return app.session.user.savePreferences({
    [SPLIT_PREFERENCE_KEY]: split
  });
}

/** Back to the default deck, rows evenly split. */
export function resetLayout() {
  return app.session.user.savePreferences({
    [PREFERENCE_KEY]: null,
    [SPLIT_PREFERENCE_KEY]: null
  });
}
flarum.reg.add('flarum-deck', 'forum/utils/deckLayout', { PREFERENCE_KEY: PREFERENCE_KEY,SPLIT_PREFERENCE_KEY: SPLIT_PREFERENCE_KEY,canUseDeck: canUseDeck,maxColumns: maxColumns,newColumnId: newColumnId,makeColumn: makeColumn,storedColumns: storedColumns,hasCustomLayout: hasCustomLayout,defaultColumns: defaultColumns,isDisplayable: isDisplayable,saveColumns: saveColumns,storedSplit: storedSplit,saveSplit: saveSplit,resetLayout: resetLayout, });